import { render } from "./NewAdmissionsChart.vue?vue&type=template&id=5690d99c&ts=true"
import script from "./NewAdmissionsChart.vue?vue&type=script&lang=ts"
export * from "./NewAdmissionsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__